<template>
  <span class="favorite-icon " :class="{ 'favorite-icon--active': !!this.count }">
    <svg xmlns="http://www.w3.org/2000/svg" width="18.5" height="18.8">
      <path class="favorite-active" fill="#FFED00" d="M15.2 2.6c-2.3-.5-4.5.9-5 3.2 0 .1-.1.3-.1.4-.3-2.4-2.4-4-4.8-3.7-.1 0-.2 0-.3.1C1.2 3.2.9 8 3 11c.2.3 4.6 5 6.4 6.9l.8.9.8-.8c1.8-2 6.1-6.6 6.3-7 2-3 1.7-7.8-2.1-8.4"/>
      <path class="favorite-border" fill="#5B5B5B" d="M9.2 17.8c-.2 0-.3-.1-.4-.2l-.8-.9c-.4-.4-.9-1-1.6-1.7-3.4-3.6-4.8-5.2-5-5.5C0 7.6-.4 5 .5 2.7 1.1 1.3 2.4.3 3.9.1c1.3-.3 2.7 0 3.8.8.6.4 1.1 1 1.4 1.7.3-.7.8-1.3 1.5-1.7 1.1-.8 2.5-1 3.8-.7 1.5.2 2.8 1.2 3.4 2.6.8 2.3.5 4.9-.9 6.8-.1.2-1.1 1.3-3.8 4.3-1 1.1-2 2.2-2.6 2.9l-.8.8c-.2.1-.4.2-.5.2zM4.9 1.2c-.3 0-.6 0-.9.1-1.1.1-2 .9-2.5 1.9-.7 2-.3 4.1.9 5.8.2.3 3.1 3.5 4.8 5.3.6.7 1.2 1.2 1.6 1.7l.4.4.4-.4c.6-.7 1.6-1.8 2.6-2.9 1.6-1.7 3.6-3.9 3.7-4.2 1.2-1.7 1.5-3.8.8-5.8-.4-1.1-1.4-1.8-2.6-1.9-1-.2-2.1 0-3 .6-.8.7-1.4 1.6-1.6 2.6 0 .3-.3.5-.6.5s-.5-.2-.6-.5c0-1-.5-1.9-1.3-2.6-.6-.4-1.3-.7-2.1-.6z"/>
    </svg>

    <i class="favorite-count">{{ count }}</i>
  </span>
</template>

<script>
export default {
  computed: {
    count() {
      return this.$store.state.favorite.favorites.length
    }
  }
}
</script>
